export default __webpack_public_path__ + "static/8-hologram-95268024692f86156d1335b9fff93418.png";